import React, { useEffect } from 'react';

import { RootState } from 'store/ducks';

import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import LoadUserInfo from 'components/LoadUserInfo';
import { Header } from 'components/Header';
import SoftHeader from 'components/SoftHeader';
import { Footer } from 'components/Footer';
import Pipefy from 'pages/Pipefy';
import Slider from 'components/Slider';
import Toast from 'components/Toast';
import BlockedItemToast from 'components/BlockedItemToast';

import './styles.scss';
import googleTagManager from 'utils/gtm';
import { IUser } from 'models/User';

const Layout: React.FC = (props: any) => {
  const { children } = props;
  const card = useSelector((state: RootState) => state.card);
  const customer = useSelector((state: RootState) => state.customer);
  const currentUser = useSelector((state: RootState) => state.user);

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = useLocation();

  useEffect(() => {
    const pageName = pathname.split('-').join(' ').slice(1);
    document.title = `Customer Care ${pageName ? '|' : ''} ${pageName.charAt(0).toUpperCase() + pageName.slice(1)
      }`;
    window.scrollTo(0, 0);
    
    if (currentUser?.id)
    {
        googleTagManager.navigation({
          location: window?.location?.href,
          title: document.title,
        }, currentUser as IUser);
    }
  }, [pathname]);

  useEffect(() => {
    if (customer?.companyName) {
      return navigate('/cliente');
    }
  }, [customer]);

  const pathNameProcess = ['/finalizacao-extravio', '/aprovacao-devolucao'];

  if (pathNameProcess.includes(location.pathname)) {
    return (
      <div className='mt-5'>
        <LoadUserInfo />
        {children}
        <Footer />
      </div>
    );
  };

  return (
    <>
      <LoadUserInfo />
      {location.pathname !== '/oauth' && <Header />}
      {location.pathname === '/manutencao' && <SoftHeader />}
      <main className="w-md-100 p-md-0 d-flex flex-column align-center mx-auto">
        <div className="relative content">{children}</div>
      </main>
      {card?.id && (
        <Pipefy
          cardNumber={card?.id}
          protocolNumber={card?.protocolNumber}
          responsibleGroup={card?.responsibleGroup}
        />
      )}
      <Toast />
      <BlockedItemToast />
      <Slider />
      <Footer />
    </>
  );
};

export default Layout;
